import {Formik} from 'formik';
import {Button, Group} from '@mantine/core';
import {MdCancel, MdCheck, MdClear} from 'react-icons/md';
import {FilterFormComponent} from './FilterFormComponent';
import {FilterFormSchema} from './FilterFormSchema';
import {toFormikValidationSchema} from 'zod-formik-adapter';
import {useBillableEventsFilter} from '../../hooks/useBillableEventsFilter';
import {I18n} from '@aws-amplify/core';

interface FilterFormProps {
    onApply: () => void;
    onCancel: () => void;
}

interface FilterFormValues {
    state?: string;
    channel?: string;
    customerId?: string;
    dayStart?: string;
    dayEnd?: string;
}

export const FilterForm = ({onApply, onCancel}: FilterFormProps) => {
    const {filters, handleSetFilters, handleClearFilters} = useBillableEventsFilter();

    const initialValues: FilterFormValues = {
        state: filters.state || '',
        channel: filters.channel || '',
        customerId: filters.customerId || '',
        dayStart: filters.dayStart || '',
        dayEnd: filters.dayEnd || '',
    };

    const onSubmit = (values: FilterFormValues) => {
        const clean = Object.entries(values).reduce((acc, [key, value]) => {
            if (value && value !== '') {
                acc[key] = value;
            }
            return acc;
        }, {} as Record<string, string>);

        handleSetFilters(clean);
        onApply();
    };

    return (
        <Formik<FilterFormValues>
            initialValues={initialValues}
            validationSchema={toFormikValidationSchema(FilterFormSchema)}
            onSubmit={onSubmit}
        >
            {({handleSubmit, resetForm}) => (
                <>
                    <FilterFormComponent/>

                    <Group justify="space-between" mt="xl">
                        <Button
                            variant="outline"
                            leftSection={<MdCancel/>}
                            onClick={onCancel}
                        >
                            {I18n.get('Cancel')}
                        </Button>
                        <Group gap="xs">
                            <Button
                                variant="outline"
                                leftSection={<MdClear/>}
                                onClick={() => {
                                    resetForm();
                                    handleClearFilters();
                                }}
                            >
                                {I18n.get('Clear')}
                            </Button>
                            <Button
                                leftSection={<MdCheck/>}
                                onClick={() => handleSubmit()}
                            >
                                {I18n.get('Apply')}
                            </Button>
                        </Group>
                    </Group>
                </>
            )}
        </Formik>
    );
};
